var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.657227 15.2381L9.10264 0.654785L17.5481 15.2381H0.657227ZM2.81098 13.9881H15.3943L9.10264 3.15479L2.81098 13.9881ZM9.10264 12.9946C9.29334 12.9946 9.4532 12.9301 9.58223 12.801C9.71126 12.672 9.77577 12.5121 9.77577 12.3215C9.77577 12.1308 9.71126 11.9709 9.58223 11.8419C9.4532 11.7128 9.29334 11.6483 9.10264 11.6483C8.91195 11.6483 8.75209 11.7128 8.62306 11.8419C8.49403 11.9709 8.42952 12.1308 8.42952 12.3215C8.42952 12.5121 8.49403 12.672 8.62306 12.801C8.75209 12.9301 8.91195 12.9946 9.10264 12.9946ZM8.47764 10.815H9.72764V6.64833H8.47764V10.815Z",
    fill: "#D61C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.75846120d6149b8f68dec5c7056825dd.svg";
export { ForwardRef as ReactComponent };